<template>
  <v-content class="pa-0">
	  <section id="hero">
          <v-row no-gutters>
            <v-carousel
              cycle
              :height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
              show-arrows-on-hover
              hide-delimiter-background
            >
              <v-carousel-item v-for="(item,i) in items" :key="i" :src="item.src">
                <v-theme-provider dark>
                  <v-row class="fill-height" align="center" justify="center">
              <v-col
                cols="12"
                class="white--text d-flex align-center justify-center flex-column py-6"
                style="background-color: rgb(0, 0, 0, 0.22);"
              >
                <h1 :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-3']" class="white--text text-center">
                  <span class="white--text font-weight-black">FUN</span>
                  <span class="cyan--text text--lighten-2 font-weight-black">EATS</span>
                </h1>
                <div :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-1']" class="font-weight-light text-center mt-2 mb-6">{{item.text}}</div>
                <v-btn
                  class=""
                  color="cyan lighten-2"
                  dark
                  large
                  @click="$router.push('/pedir')"
                >
                  <span class="black--text">Realizar pedido</span>
                </v-btn>
              </v-col>
            </v-row>
                </v-theme-provider>
              </v-carousel-item>
            </v-carousel>
          </v-row>
        </section>

    <section>
      <v-container class="my-12">
        <v-row>
          <v-col cols="12" class="my-4">
            <h2 class="headline text-center">La forma más fácil de pedir online</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-card flat class="transparent">
              <v-card-text class="text-center">
                <v-icon x-large class="cyan--text text--lighten-2">mdi-palette</v-icon>
              </v-card-text>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline text-center">Personaliza tu pedido</div>
              </v-card-title>
              <v-card-text>Con Fun Eat podrás elegir desde la bebida al postres. Diseñar la poke bowl como más te guste o sencillamente aprovechar las mejores ofertas. Sólo piensa, ¿Que te apetece hoy?</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card flat class="transparent">
              <v-card-text class="text-center">
                <v-icon x-large class="cyan--text text--lighten-2">mdi-flash</v-icon>
              </v-card-text>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">La aplicación más rápida</div>
              </v-card-title>
              <v-card-text>¿Estás registrado? Podrás hacerlo durante el proceso y terminar tu pedido en menos de 5 minutos y, por supuesto, de la forma más cómoda con diversos métodos de pago. Te le llevaremos directamente a tu casa.</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card flat class="transparent">
              <v-card-text class="text-center">
                <v-icon x-large class="cyan--text text--lighten-2">mdi-wrench</v-icon>
              </v-card-text>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline text-center">Un buen equipo</div>
              </v-card-title>
              <v-card-text>Trabajamos para ofrecerte el mejor servicio, ¿tienes algún problema? No dudes en contactarnos, le daremos solución lo antes posible. Lo más importante es tu experiencia y que disfrutes de lo que más te gusta en casa.</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: "/img/portada/imgCarrusel-1.jpg",
          text: "Haz tu pedido online"
        },
        {
          src: "/img/portada/imgCarrusel-2.jpg",
          text: "Frescos frutería de confianza"
        },
        {
          src: "/img/portada/imgCarrusel-3.jpg",
          text: "Te lleva los productos a casa"
        }
      ],

      model: 0,
      showArrows: false,
      hideDelimiters: true,
      cycle: false
    };
  }
};
</script>

<style>
.border {
  border: 1px solid rgb(0, 0, 0);
}
.borderB {
  border: 1px solid rgb(255, 255, 255);
}
</style>